"use strict";

exports.validateUrl = function (str) {
    if (!str) {
        return true;
    }
    var url = new URL(str);
    return url.protocol === "http:" || url.protocol === "https:";
};